<template>
  <div>
    <s-dialog :open="true" to="stds-dialog-survey">
      <s-dialog-overlay />
      <s-dialog-panel class="w-[39.2rem]">
        <st-dialog-header @clickClose="onClose" />
        <s-dialog-content>
          <s-dialog-content-body class="flex flex-col items-center justify-center gap-20">
            <safe-html
              tag="h6"
              class="text-title5 text-center text-wrap font-bold"
              :html="$t('studio.group_home.survey_popup_title')"
            />
            <figure>
              <img
                src="@/assets/images/survey/survey_popup.svg"
                alt="Survey popup illustration"
                width="165"
                height="120"
                loading="lazy"
              />
            </figure>
            <safe-html
              tag="p"
              class="text-center text-[1.4rem]"
              :html="
                $t('studio.group_home.survey_popup_guide1', {
                  surveyStartDate: surveyStartTime,
                  surveyEndDate: surveyEndTime
                })
              "
            />
          </s-dialog-content-body>
        </s-dialog-content>
        <s-dialog-footer class="flex flex-col items-center justify-center gap-12">
          <s-button
            class="!w-[25.6rem] text-wrap text-center"
            variant="primary"
            @click="openSurveyLink"
          >
            {{ $t('studio.group_home.survey_popup_btn_go_to_survey') }}
          </s-button>
          <span
            class="text-on-surface-elevation-3 cursor-pointer text-md font-regular"
            @click="closeForToday"
          >
            {{ $t('studio.group_home.survey_popup_btn_ignore_one_day') }}
          </span>
        </s-dialog-footer>
      </s-dialog-panel>
    </s-dialog>

    <s-portal-target name="stds-dialog-survey" />
  </div>
</template>

<script setup lang="ts">
import { DateTime } from 'luxon';
import { computed } from 'vue';

import SafeHtml from '@/components/common/safe-html.vue';
import StDialogHeader from '@/components/common/st-dialog-header.vue';
import {
  SURVEY_END_TIME,
  SURVEY_FORMAT,
  SURVEY_LINK,
  SURVEY_START_TIME
} from '@/constants/common.const';

const emits = defineEmits<{
  close: [];
}>();

const openSurveyLink = () => {
  window.open(SURVEY_LINK, '_blank');
};

const onClose = () => {
  emits('close');
};

const surveyStartTime = computed(() => {
  return DateTime.fromJSDate(SURVEY_START_TIME).toFormat(SURVEY_FORMAT);
});

const surveyEndTime = computed(() => {
  return DateTime.fromJSDate(SURVEY_END_TIME).toFormat(SURVEY_FORMAT);
});

const closeForToday = () => {
  localStorage.setItem('surveyPopupCloseDate', new Date().toISOString());
  onClose();
};
</script>
